import { Component, Link } from '@mna/react'
import LoadingScreen from 'features/LoadingScreen'
import Results from './Results'

const hasClinics = state =>
  state.triageResponse.emergencySessionResults.clinics
    && state.triageResponse.emergencySessionResults.clinics.length

export default class EmergencySection extends Component {

  state = {
    isLoading: !hasClinics(this.props.state)
  }

  async componentDidMount() {

    const { state, actions } = this.props
    const { triageRequest: { location = {} } } = state
    state.triageRequest.activeMenu = "emergency"
    localStorage.setItem('careoption', "Emergency Room")
    if (hasClinics(state)) return

    try {

      // Get emergency number if different from "911"

      const country = location.parts && location.parts.country

      if (country && ['United States', 'Canada'].indexOf(country) < 0 && !state.isFacility) {
        await actions.getTriageEmergencyNumber({ country })
      }

      await actions.getTriageEmergencyResults()

      this.setState({ isLoading: false })

      // Submit on "done" screen instead
      //actions.submitTriageSession()

    } catch(e) {
      console.log(e)
    }

  }

  render() {

    return (
      <LoadingScreen isLoading={this.state.isLoading}>
        <Results {...this.props} />
      </LoadingScreen>
    )
  }
}
